import { FormConfig, FormValues, NextFunction } from '@topdanmark-onlinesolutions/claim-form-types';
import { getValueOrDefault } from '../components/values/Get';

export const getNextPage: NextFunction = async (curPageId: string, formConfig: FormConfig, formValues: FormValues) => {
    let nextPage: string | undefined = '';

    switch (curPageId) {
        case 'godt-at-vide':
            nextPage = 'hvornaar-skete-skaden';
            break;
        case 'hvornaar-skete-skaden':
            nextPage = 'adresse';
            break;

        case 'adresse':
            nextPage = 'hvor-er-skaden-sket';
            break;

        case 'hvor-er-skaden-sket':
            if (getValueOrDefault(formConfig, formValues, 'hvorerskadensket').value === 'indeIEnBygning') {
                nextPage = 'synligt-eller-skjult-roer';
            } else {
                nextPage = 'hvilke-problemer';
            }
            break;
        case 'synligt-eller-skjult-roer':
            if (getValueOrDefault(formConfig, formValues, 'errretkabletsynligtellerskjult').value === 'skjult') {
                nextPage = 'hvilket-roer';
            } else {
                nextPage = 'eventuelle-kommentarer';
            }
            break;

        case 'hvilket-roer':
            nextPage = 'eventuelle-kommentarer';
            break;
        case 'hvilke-problemer':
            nextPage = 'eventuelle-kommentarer';
            break;

        case 'eventuelle-kommentarer':
            nextPage = 'dokumentation';
            break;
        case 'dokumentation':
            nextPage = 'reparation';
            break;
        case 'reparation':
            nextPage = 'om-dig';
            break;
        case 'om-dig':
            nextPage = 'andet-selskab';
            break;
        case 'andet-selskab':
            if (
                getValueOrDefault(formConfig, formValues, 'harduenforsikringietandetselskabsomdkkerdetsamme').value ===
                'Ja'
            ) {
                nextPage = 'hvilket-selskab';
            } else {
                nextPage = 'resume';
            }
            break;
        case 'hvilket-selskab':
            nextPage = 'resume';
            break;
        case 'resume':
            nextPage = undefined;
            break;

        default:
            throw new Error('Unknown page: ' + curPageId);
    }

    return nextPage;
};
